import { ETables } from '../types/enums/ETables';

export const capitalize = (str: string) => str.charAt(0).toLocaleUpperCase() + str.substring(1, str.length);

export const getIdsFromTableFilters = (filters: any) => {
  // console.log(filters);

  return Object.keys(filters).reduce((acc: any, curr) => {
    filters[curr].users?.forEach((user: any) => user.checked && acc.push(user._id));
    return acc;
  }, []);
};

export const formattColumnName = (id: string, tableName: string): string => {
  if (id === 'id') return '_id';

  if (tableName === ETables.SystemUsers && id === 'name') return 'nameSurname';

  return id;
};
